import { useState, useCallback } from "react";
import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations, useLanguage } from "contexts/LocalizationContext";
import getPageUrl from "utils/getPageUrl";
import { trackEvents } from "utils/trackingUtils";
import { HERO_CHECK_COMPENSATION_GTM, HERO_CHECK_COMPENSATION_MP } from "modules/home-page/trackingConsts";
import type { AutocompleteFormProps } from "./AutocompleteForm.d";
import { AutocompleteInput } from "./AutocompleteInput";
import { FUNNEL_AB_PARAMETER } from "./consts";

const { Button, Grid } = Chakra;

export const AutocompleteForm = ({ ctaVariant = "secondary", buttonText }: AutocompleteFormProps) => {
  const translations = useTranslations();
  const language = useLanguage();
  const [departureAirport, setDepartureAirport] = useState(null);
  const [arrivalAirport, setArrivalAirport] = useState(null);
  const [funnelAbParameter, setFunnelAbParameter] = useState("");

  const getWebappPath = useCallback(() => {
    const departureAirportValue = departureAirport ? departureAirport.iata : "";
    const arrivalAirportValue = arrivalAirport ? arrivalAirport.iata : "";

    return `${getPageUrl(
      language,
      "webappNewClaim"
    )}&departureAirportIata=${departureAirportValue}&arrivalAirportIata=${arrivalAirportValue}${funnelAbParameter}`;
  }, [arrivalAirport, departureAirport, language, funnelAbParameter]);

  const onClickHandler = () => {
    if (window?.funnelAb) setFunnelAbParameter(FUNNEL_AB_PARAMETER);
    trackEvents({ gtmEvent: HERO_CHECK_COMPENSATION_GTM, mixpanelEvent: HERO_CHECK_COMPENSATION_MP });
  };

  return (
    <Grid templateColumns={{ base: "1fr", md: "repeat(3, minmax(0, 1fr))" }} columnGap={2} rowGap={2}>
      <AutocompleteInput
        placeholder={translations("departure_airport")}
        setAirportSelected={setDepartureAirport}
        autoFocus
        dataTestId="hero-departure-input"
      />
      <AutocompleteInput
        placeholder={translations("arrival_airport")}
        setAirportSelected={setArrivalAirport}
        dataTestId="hero-destination-input"
      />
      <Button
        as="a"
        variant={ctaVariant}
        title={translations("check_compensation")}
        href={getWebappPath()}
        h="50px"
        mt={{ base: 4, md: 0 }}
        onClick={onClickHandler}
        data-testid="hero-cta-button"
      >
        {buttonText || translations("check_compensation")}
      </Button>
    </Grid>
  );
};
